import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=092ef7a8&scoped=true"
import script from "./Property.vue?vue&type=script&lang=js"
export * from "./Property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092ef7a8",
  null
  
)

export default component.exports